export default __webpack_public_path__ + "static/lines-thin-3485c4fc5923f4e5cc609f6563315520.svg";